import { NewFieldStyleOverrides, TextField } from "~components";
import { Css } from "~generated/css";
import { useTestIds } from "~utils";

type CodeEntryFieldProps = {
  value: string;
  onChange: (value: string) => void;
  onEnter: () => void;
  disabled: boolean;
  error?: string | null;
  codeResent?: boolean;
};

export function CodeEntryField(props: CodeEntryFieldProps) {
  const { value, onChange, onEnter, disabled, error, codeResent } = props;
  const tid = useTestIds(props, "codeEntryField");
  return (
    <div css={Css.w100.$}>
      <TextField
        {...tid}
        cssOverrides={{
          ...NewFieldStyleOverrides,
          ...(error && Css.brightStrawberry.$),
        }}
        label={<div css={Css.t14.gray700.ttn.mb1.$}>Enter Code</div>}
        autoComplete="one-time-code"
        type="text"
        inputMode="numeric"
        placeholder="000000"
        value={value}
        onChange={(_, value) => onChange(value)}
        onKeyDown={(_, key) => {
          if (key === "Enter") {
            onEnter();
          }
        }}
        disabled={disabled}
      />
      <div css={Css.pt(0.5).t12.$}>
        {/* If we have both prioritize error */}
        {error ? (
          <div css={Css.brightStrawberry.$}>{error}</div>
        ) : (
          codeResent && <div css={Css.saturatedGrass.$}>We have resent a code. Please check your email.</div>
        )}
      </div>
    </div>
  );
}
